// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__18NnW","inputWrap":"CustomTip_inputWrap__-wT98"};